<template>
    <div>
        <!-- <div v-if="authUserPermission['characteristic-item-name-view']"> -->
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0"></h6>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div class="card mb-1">
                <div class="card-header mt--4 mb--4">
                    <div class="row">
                        <div class="col">
                            <h3 class="mb-0">
                                <router-link to="/vendor/vendor"><a href=""><i
                                            class="fa fa-arrow-left mr-3 text-dark"></i></a></router-link>
                                {{ tt('vendor_profiling') }}
                            </h3>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <input type="text" class="form-control form-control-sm text-center border-radius-20"
                                    v-model="valImport.search" placeholder="Search Vendor Profilling" />
                                <!-- v-on:keyup="filter"                             -->
                            </div>
                        </div>
                        <div class="col text-right">
                            <base-button class="btn-dark" style="margin-top:1px; margin-right:5px;" size="sm" type="default"
                                @click="importModal">
                                <span>{{ tt('import') }}</span>
                            </base-button>
                            <base-button class="btn-success" style="margin-top:1px" size="sm" type="default"
                                @click="exportFile">
                                <span>{{ tt('export') }}</span>
                            </base-button>
                        </div>
                    </div>
                </div>
                <template>
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered" style="height: 400px" v-if="!onLoad">
                            <thead class="thead-light">
                                <tr>
                                    <th colspan="6" class="text-center align-middle" style="background-color: #f8f9fa; font-weight: bold; font-size: 14px;">
                                        VENDOR DETAILS
                                    </th>
                                    <th colspan="5" class="text-center align-middle" style="background-color: #f3dede; font-weight: bold; font-size: 14px;">
                                        POTENTIAL DUPLICATE
                                    </th>
                                    <th rowspan="2" class="text-center align-middle" style="background-color: #e8f5e8; font-weight: bold; font-size: 14px;">NOTES</th>
                                </tr>
                                <tr>
                                    <th class="text-center align-middle" style="width: 120px;">{{ tt('vendor_number') }}</th>
                                    <th class="text-center align-middle" style="width: 180px;">{{ tt('name') }}</th>
                                    <th class="text-center align-middle" style="width: 130px;">NPWP</th>
                                    <th class="text-center align-middle" style="width: 130px;">NIB</th>
                                    <th class="text-center align-middle" style="width: 130px;">PHONE</th>
                                    <th class="text-center align-middle" style="width: 180px;">EMAIL</th>
                                    <th class="text-center align-middle" style="width: 120px; background-color: #f3dede;">BY NAME</th>
                                    <th class="text-center align-middle" style="width: 120px; background-color: #f3dede;">BY NPWP</th>
                                    <th class="text-center align-middle" style="width: 120px; background-color: #f3dede;">BY NIB</th>
                                    <th class="text-center align-middle" style="width: 120px; background-color: #f3dede;">BY PHONE</th>
                                    <th class="text-center align-middle" style="width: 120px; background-color: #f3dede;">BY EMAIL</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="row in filteredRows" :key="row.vendor_number">
                                    <td class="text-center align-middle">{{ row.vendor_number }}</td>
                                    <td class="align-middle wrap-text">{{ row.name }}</td>
                                    <td class="text-center align-middle">{{ row.npwp }}</td>
                                    <td class="text-center align-middle">{{ row.nib }}</td>
                                    <td class="text-center align-middle">{{ row.phone }}</td>
                                    <td class="text-center align-middle">{{ row.email }}</td>
                                    <td class="text-left align-middle">
                                        <div v-if="row.list_duplicate && row.list_duplicate.length > 0">
                                            <div v-for="(dup, idx) in row.list_duplicate" :key="'name-' + idx" class="small-font">
                                                {{ dup.vendor_number }} - {{ dup.name }} 
                                                <span class="badge badge-info">{{ Math.round(dup.score_name) }}%</span>
                                            </div>
                                        </div>
                                        <div v-else class="text-success">
                                            <i class="fas fa-check"></i> No duplicates
                                        </div>
                                    </td>
                                    <td class="text-left align-middle">
                                        <div v-if="row.list_duplicate && row.list_duplicate.length > 0">
                                            <div v-for="(dup, idx) in row.list_duplicate" :key="'npwp-' + idx" class="small-font">
                                                {{ dup.npwp }} 
                                                <span class="badge badge-info">{{ Math.round(dup.score_npwp) }}%</span>
                                            </div>
                                        </div>
                                        <div v-else class="text-success">
                                            <i class="fas fa-check"></i> No duplicates
                                        </div>
                                    </td>
                                    <td class="text-left align-middle">
                                        <div v-if="row.list_duplicate && row.list_duplicate.length > 0">
                                            <div v-for="(dup, idx) in row.list_duplicate" :key="'nib-' + idx" class="small-font">
                                                {{ dup.nib }} 
                                                <span class="badge badge-info">{{ Math.round(dup.score_nib) }}%</span>
                                            </div>
                                        </div>
                                        <div v-else class="text-success">
                                            <i class="fas fa-check"></i> No duplicates
                                        </div>
                                    </td>
                                    <td class="text-left align-middle">
                                        <div v-if="row.list_duplicate && row.list_duplicate.length > 0">
                                            <div v-for="(dup, idx) in row.list_duplicate" :key="'phone-' + idx" class="small-font">
                                                {{ dup.phone }} 
                                                <span class="badge badge-info">{{ Math.round(dup.score_phone) }}%</span>
                                            </div>
                                        </div>
                                        <div v-else class="text-success">
                                            <i class="fas fa-check"></i> No duplicates
                                        </div>
                                    </td>
                                    <td class="text-left align-middle">
                                        <div v-if="row.list_duplicate && row.list_duplicate.length > 0">
                                            <div v-for="(dup, idx) in row.list_duplicate" :key="'email-' + idx" class="small-font">
                                                {{ dup.email }} 
                                                <span class="badge badge-info">{{ Math.round(dup.score_email) }}%</span>
                                            </div>
                                        </div>
                                        <div v-else class="text-success">
                                            <i class="fas fa-check"></i> No duplicates
                                        </div>
                                    </td>
                                    <td class="align-middle">
                                        <div v-if="row.notes" class="notes-container wrap-text">
                                            <div v-for="(note, index) in row.notes.split(';')" :key="index" class="notes-item">
                                                <small class="text-muted">
                                                    <strong>{{ index + 1 }}.</strong>
                                                    {{ note.trim() }}
                                                </small>
                                            </div>
                                        </div>
                                        <div v-else class="text-muted">-</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <page-loading v-else />
                    </div>
                </template>

                <div class="card-footer pb-0 ">
                    <!-- <span class="float-left">
                            <base-pagination :page-count="valImport.last_page"
                                v-model="valImport.current_page"
                                @click.native="changePage(valImport.current_page)" size="sm"></base-pagination>
                        </span>
                        <span class="float-right">
                            {{ tt('page_info', {size: (valImport.current_page - 1) * valImport.per_page + valImport.data.length, total: valImport.total})}}
                        </span> -->
                </div>
            </div>
        </div>
        <validation-observer v-slot="{ invalid }">
            <modal :show.sync="modalImport.show" size="lg">
                <template slot="header">
                    <h5 class="modal-title">{{ tt('import_vendor_profiling') }}</h5>
                </template>
                <div>
                    <div class="alert alert-info mb-3">
                        <!-- <strong>Information:</strong> -->
                        <strong>The imported data will be automatically corrected by the system according to the
                            following
                            rules:</strong>
                        <ul>
                            <!-- <li>The imported data will be automatically corrected by the system according to the following rules:</li> -->
                            <li><b>name</b>: Will be converted to uppercase, no double spaces, and no symbols.</li>
                            <li><b>province, city, country, bank_name, bank_account_name, pic_name</b>: Will be
                                converted to
                                uppercase.</li>
                            <li><b>email</b>: Will be validated as email.</li>
                            <li><b>npwp</b>: Will be validated as NPWP.</li>
                            <li><b>phone</b>: Will be validated as PHONE.</li>
                            <li><b>status</b>: Required field.</li>
                            <li>Other columns will be formatted as required by the system.</li>
                        </ul>
                    </div>
                    <label class="form-control-label">File<span class="text-danger">*</span></label>
                    <file-input @change="changeImport" ref="fileImportVendorProfiling"></file-input>
                </div>
                <template slot="footer">
                    <base-button type="primary" v-on:click="importFile"
                        :disabled="modalImport.onLoad || invalid || !modalImport.file">
                        <span v-if="modalImport.onLoad"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait')
                        }}</span>
                        <span v-else>
                            <span>Import</span>
                        </span>
                    </base-button>
                </template>
            </modal>
        </validation-observer>
        <!-- </div>
        <noaccess v-else /> -->
    </div>
</template>
<script>
import { mapState } from 'vuex'
import Api from '@/helpers/api';
import importReport from '@/services/report/import.service';


export default {
    // watch: {

    // },
    data() {
        return {
            onLoad: false,
            onLoadCharValue: false,
            valImport: {
                search: "",
                current_page: 0,
                from: 0,
                last_page: 0,
                per_page: 0,
                to: 0,
                total: 0,
                data: [],
            },
            modalImport: {
                show: false,
                file: '',
                onLoad: false,
            }
        }
    },
    computed: {
        ...mapState({
            authUserPermission: state => state.auth.userPermission
        }),
        filteredRows() {
            const term = (this.valImport.search || '').toString().trim().toLowerCase();
            if (!term) return this.valImport.data;

            return this.valImport.data.filter(row => {
                const haystacks = [
                    row.vendor_number,
                    row.name,
                    row.npwp,
                    row.nib,
                    row.phone,
                    row.email,
                    row.notes
                ];

                if (Array.isArray(row.list_duplicate)) {
                    row.list_duplicate.forEach(dup => {
                        haystacks.push(
                            dup.vendor_number,
                            dup.name,
                            dup.npwp,
                            dup.nib,
                            dup.phone,
                            dup.email
                        );
                    });
                }

                return haystacks.some(val => {
                    if (val == null) return false;
                    return String(val).toLowerCase().includes(term);
                });
            });
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.onLoad = true;
            // Jika ada data yang sudah di-import sebelumnya, tampilkan
            // Atau bisa juga memanggil API untuk memuat data yang sudah ada
            setTimeout(() => {
                this.onLoad = false;
                console.log('Data saat ini:', this.valImport.data);
            }, 1000);
        },
        changeImport(files) {
            this.modalImport.file = files[0]
        },
        importModal() {
            this.modalImport.show = true;
            this.modalImport.onLoad = false;
        },
        importFile() {
            let context = this;
            let formData = new FormData();
            this.modalImport.onLoad = true;

            formData.append('excel', this.modalImport.file);
            Api(context, importReport.import_vendor_profiling(formData)).onSuccess(function (response) {
                const rawData = response.data.data;

                if (rawData && rawData.length > 0) {
                    // Transform data tanpa grouping, tampilkan per vendor number
                    const transformedData = rawData.map(item => ({
                        vendor_number: item.vendor_number,
                        name: item.name,
                        type: item.type,
                        status: item.status,
                        address_1: item.address_1,
                        city: item.city,
                        province: item.province,
                        npwp: item.npwp,
                        nib: item.nib,
                        phone: item.phone,
                        email: item.email,
                        notes: item.notes,
                        list_duplicate: item.list_duplicate || []
                    }));

                    context.valImport.data = transformedData;
                    console.log('Data setelah import:', context.valImport.data);
                    context.$notify({
                        message: response.data.message,
                        type: "success",
                        verticalAlign: "bottom",
                        horizontalAlign: "left"
                    });
                } else {
                    context.$notify({
                        message: 'Tidak ada data yang ditemukan dalam file',
                        type: "warning",
                        verticalAlign: "bottom",
                        horizontalAlign: "left"
                    });
                }
            }).onError(function (error) {
                context.$notify({
                    message: 'Error',
                    type: 'red'
                });
            }).onFinish(function () {
                console.log("masuk finish")
                context.modalImport.show = false;
                context.modalImport.onLoad = false;
                context.$refs.fileImportVendorProfiling.value = ""
            }).call();
        },
        exportFile() {
            let context = this;
            context.onLoad = true;
            importReport.export_vendor_profiling({})
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    // Nama file bisa disesuaikan sesuai response header jika ada
                    link.setAttribute('download', 'vendor_profiling_export.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    context.$notify({
                        message: 'Export berhasil',
                        type: 'success',
                        verticalAlign: 'bottom',
                        horizontalAlign: 'left'
                    });
                })
                .catch(error => {
                    context.$notify({
                        message: 'Export gagal',
                        type: 'danger',
                        verticalAlign: 'bottom',
                        horizontalAlign: 'left'
                    });
                })
                .finally(() => {
                    context.onLoad = false;
                });
        },
        changePage(page) {
            console.log(page)
            // let context = this;
            // context.onLoad.table = true;
            // context.onLoad.detail = true;
            // clearTimeout(this.loadTimeout);
            // this.loadTimeout = setTimeout(() => {
            //     this.get();
            // }, 100);
        },
        changePageCharValue(page) {
            console.log(page)
            // let context = this;
            // context.onLoadCharValue = true;

            // clearTimeout(this.loadTimeout);
            // this.loadTimeout = setTimeout(() => {
            //     this.getCharValue()
            // }, 100);
        },
        getSplittedDomain(val) {

            const domain = val.match(/^https?:\/\/([^\/.]+(?:\.[^\/.]+)+)/i);
            console.log("getSplittedDomain", domain)

            return domain ? domain[1] : val;
        }
    }
};
</script>
<style scope>
.selected-row {
    background-color: #ecf5ff;
    color: white;
}

div.el-table tbody td,
div.el-table thead th {
    padding: 0rem;
}

.form-control-sm {
    height: 25px
}

.filter.mb--1:hover {
    color: #e9ecef;
    cursor: pointer;
}

.el-table__body tr.current-row>td {
    background-color: #ffe391 !important;
}

.el-table th .cell {
    white-space: normal !important;
    word-break: break-word !important;
}

.wrap-pre {
    white-space: pre-wrap;
    word-break: break-word;
    word-wrap: break-word;
}

.notes-container {
    max-height: 200px;
    overflow-y: auto;
}

.notes-item {
    padding: 2px 0;
    border-bottom: 1px solid #f0f0f0;
}

.notes-item:last-child {
    border-bottom: none;
}

/* Tambahan CSS untuk tabel yang lebih rapi */
.el-table {
    width: 100% !important;
    table-layout: fixed !important;
}

.el-table .el-table__cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.el-table .el-table__cell .cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 8px 12px;
}

/* Untuk kolom yang memerlukan text wrapping */
.el-table .el-table__cell .cell.wrap-text {
    white-space: normal;
    word-break: break-word;
    line-height: 1.4;
}

/* Memastikan tabel responsive */
.table-responsive {
    overflow-x: auto;
    overflow-y: hidden;
}

/* Mengatur spacing antar kolom */
.el-table th,
.el-table td {
    border-right: 1px solid #ebeef5;
}

.el-table th:last-child,
.el-table td:last-child {
    border-right: none;
}

/* Memperbaiki alignment badge */
.badge {
    display: inline-block;
    padding: 4px 8px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 4px;
}

.badge-info {
    background-color: #17a2b8;
    color: white;
}

.badge-warning {
    background-color: #ffc107;
    color: #212529;
}

/* Memastikan tabel tidak overflow */
/* .el-table__body-wrapper {
    overflow-x: auto;
} */

/* Mengatur tinggi baris yang konsisten */
/* .el-table__row {
    height: auto !important;
    min-height: 60px;
} */

/* Memperbaiki padding cell */
/* .el-table td {
    padding: 8px 0;
} */

/* Memastikan text tidak terpotong */
/* .el-table .cell {
    padding: 8px 12px;
    line-height: 1.4;
} */

/* Untuk kolom dengan konten panjang */
.wrap-text {
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
}

.potential-duplicate-table {
    width: 100%;
    font-size: 12px;
    background: #f8f9fa;
    border-collapse: collapse;
}

.potential-duplicate-table th,
.potential-duplicate-table td {
    border: 1px solid #dee2e6;
    padding: 4px 8px;
    text-align: left;
    vertical-align: middle;
    white-space: nowrap;
}

.potential-duplicate-table th {
    background: #f3dede;
    color: #333;
    font-weight: bold;
    text-align: center;
}

.potential-duplicate-table tr:nth-child(even) {
    background: #f9f9f9;
}
</style>